import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { reportKey } from "@/profitability/query";
import type { ReportBuildStatus } from "@/profitability/types";

/** Rereads the template's build history when a build finishes. */
export const useBuildHistoryRefresh = (
  businessId: string,
  buildStatus: ReportBuildStatus | undefined,
) => {
  const client = useQueryClient();
  const lastBuildStatus = useRef(buildStatus);
  useEffect(() => {
    if (lastBuildStatus.current === "building" && buildStatus !== "building")
      void client.invalidateQueries({
        queryKey: [...reportKey(businessId), "history"],
      });
    lastBuildStatus.current = buildStatus;
  }, [buildStatus, businessId, client]);
};
